import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

const ForgotPassword = () => {
	const [email, setEmail] = useState("")
	const [submitted, setSubmitted] = useState(false)
	const [isLoading, setIsLoading] = useState(false)

	const handleSubmit = async (e) => {
		e.preventDefault()
		setIsLoading(true)
		try {
			const { data } = await axios.post(
				`${process.env.REACT_APP_WEB_URL}forgot-password`,
				{ email },
				{ withCredentials: true }
			)
			setSubmitted(true)
		} catch (error) {
			toast.error("Something went wrong. Please try again later.", {
				position: "top-right"
			})
		} finally {
			setIsLoading(false)
		}
	}

	if (submitted) {
		return (
			<>
				<div className="login">
					<div className="login__forms">
						<div className="col-md-6 col-12">
							<div className="form__wrap">
								<h1 className="text-align--center">Check your email</h1>
								<p className="text-align--center">If an account exists with that email, we've sent a password reset link. It will expire in 1 hour.</p>
								<Link className="form__link" to="/login">Back to login</Link>
							</div>
						</div>
					</div>
				</div>
			</>
		)
	}

	return (
		<>
			<div className="login">
				<div className="login__forms">
					<div className="col-md-6 col-12">
						<div className="form__wrap">
							<h1 className="text-align--center">Forgot Password</h1>
							<p className="text-align--center">Enter your email address and we'll send you a link to reset your password.</p>
							<form onSubmit={handleSubmit}>
								<div className="form__group">
									<label htmlFor="email" className="form__label">Email</label>
									<input
										className="form__input"
										type="email"
										name="email"
										value={email}
										placeholder="Email"
										onChange={(e) => setEmail(e.target.value)}
										required
									/>
								</div>
								<button className="form__button" type="submit" disabled={isLoading}>
									{isLoading ? "Sending..." : "Send Reset Link"}
								</button>
							</form>
							<Link className="form__link" to="/login">Back to login</Link>
						</div>
					</div>
				</div>
			</div>
			<ToastContainer />
		</>
	);
};

export default ForgotPassword
